import { Autocomplete, CircularProgress, IconButton, InputAdornment, Paper, TextField } from '@mui/material'
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react'
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import RestrictionsModal from '../RestrictionsModal';
import { FormsEditProps } from '../../../pages/vendors/models';
import { KTSVG } from '../../../../_metronic/helpers';
import ClearIcon from '@mui/icons-material/Clear';
import { checkErrorAPICall } from '../../../helpers/checkErrorAPICall';
import { stylesMUIInput } from '../../stylesMUIInput';
import { InputStyled } from '../../Inputs.styled';
import { RootState } from '../../../../setup';

const GET_AVAILABLEAPIS = '/api/v1/system/availableapis'

const APIIntegration = ({APISelected, setAPISelected, formik, testConnection, testingConnection, rowSelected, availableApis, setAvailableApis}: FormsEditProps) => {
    const dispatch = useDispatch()
    const [searchApi, setSearchAPI] = useState('')
    const [openRestrictionsModal, setOpenRestrictionsModal] = useState(false)
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number

    const useStyles = makeStyles({
        textField: {
            backgroundColor: 'white',
            border: (formik.errors?.APIIntegration?.APIList) ? '1px solid #F1416C !important' : '1px solid #E4E6EF !important',
            borderRadius: '0.475rem',
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                border: 'none'
            },
            "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                border: 'none'
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
                color: "#5E6278"
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: 'none',
            },
            "& .MuiOutlinedInput-root":{
                color: "#5E6278"
            }
        },
        height: {
            height: 53.13,
        }
    })
    const classesAutocomplete = useStyles()

    useEffect(() => {
        if(availableApis.length === 0){
            axios.get(GET_AVAILABLEAPIS)
            .then((results) => {
                setAvailableApis(results.data.data.results?.filter(result => result.APICode !== 'PRIMUSTARIFF'))
            }).catch(error => {
                checkErrorAPICall(error, dispatch, 'Get available Apis')
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(availableApis.length > 0){
            formik.setFieldValue('APIIntegration.APIList', rowSelected?.APICredentials?.API || '')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availableApis])

    useEffect(() => {
        setAPISelected(availableApis.filter(api => api.APICode === formik.values.APIIntegration.APIList)[0])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availableApis.filter(api => api.APICode === formik.values.APIIntegration.APIList)[0]])

    return (
        <>
            <div className="row align-items-center">
                <div className="col-12 col-sm-2 col-md-1 mb-0 mb-sm-5 mb-md-0">
                    <label className='form-label'>API List</label>
                </div>
                <div className="col-12 col-sm-10 col-md-3 mb-5 mb-md-0">
                    <Autocomplete
                        disablePortal
                        isOptionEqualToValue={(option, value) => option?.APIName === value?.APIName}
                        autoComplete={false}
                        className="dropdownContainer w-100"
                        getOptionLabel={(option) => option?.APIName}
                        options={availableApis}
                        handleHomeEndKeys
                        inputValue={searchApi || ''}
                        value={availableApis.filter(api => api.APICode === formik.values.APIIntegration.APIList)[0] || null}
                        clearOnBlur={false}
                        onInputChange={(e, value) =>  {
                            setSearchAPI(value || '')
                        }}
                        onChange={(event, value) => {
                            formik.setFieldValue('APIIntegration.APIList', value?.APICode || '')
                            formik.setFieldValue('additionalInformation.SCAC', value?.APICode ? (value?.SCAC || '') : '')
                            formik.setFieldError('APIIntegration', {})
                        }}
                        renderInput={params => {
                            return (
                                <TextField
                                    {...params}
                                    fullWidth
                                    autoComplete='new-password'
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {
                                                    formik.values.APIIntegration.APIList &&
                                                    <IconButton
                                                        size='small'
                                                        className='me-1'
                                                        onClick={() => {
                                                            setSearchAPI('')
                                                            formik.setFieldValue('APIIntegration.APIList', '')
                                                            formik.setFieldError('APIIntegration', {})
                                                        }}
                                                    >
                                                        <ClearIcon style={{color: '#a1a5b7'}} />
                                                    </IconButton>
                                                }
                                                <KTSVG path='/media/icons/bootstrap/search.svg' className='svg-icon svg-icon-6' style={{color: '#a1a5b7'}}/>
                                            </InputAdornment>
                                        ),
                                        className: classesAutocomplete.height,
                                        style: stylesMUIInput(fontSize)
                                    }}
                                    className={classesAutocomplete.textField}
                                />
                            );
                        }}
                        PaperComponent={({ children }) => (
                            <Paper style={{ fontFamily: "Poppins", color:"#5E6278", fontSize: 14, fontWeight: 500 }}>
                                {children}
                            </Paper>
                        )}
                        noOptionsText={<div style={{fontWeight: 500, color: "#a1a5b6"}}>No options</div>}
                    />
                    <div>
                        {formik.errors?.APIIntegration?.APIList
                            ? <small className="text-danger">Required</small>
                            : null
                        }
                    </div>
                </div>
                {
                    APISelected?.APICode !== 'CARGOCHIEF'
                    ? null
                    : <>
                        <div className="col-4"></div>
                        <div className="col-4 d-flex justify-content-end">
                            <button
                                className='btn btn-primary w-100'
                                onClick={() => setOpenRestrictionsModal(true)}
                            >
                                Set Restrictions
                            </button>
                        </div>
                    </>
                }
                {
                    APISelected?.APICode !== 'CARGOCHIEF' && ['UPS', 'UPSRESTAPI', 'UPSSPRESTAPI', 'UPSSPRESTVOLUME'].indexOf(APISelected?.APICode) === -1 ?
                        <>
                            <div className="col-12 col-sm-2 col-md-1">
                                <label className='form-label'>Username</label>
                            </div>
                            <div className="col-12 col-sm-4 col-md-3 mb-5 mb-sm-0">
                                <InputStyled
                                    type="text"
                                    className="form-control"
                                    autoComplete='off'
                                    {...formik.getFieldProps('APIIntegration.username')}
                                    fontSize={fontSize}
                                    error={formik.errors.APIIntegration?.username && formik.touched.APIIntegration?.username}
                                />
                                {formik.errors.APIIntegration?.username && formik.touched.APIIntegration?.username
                                    ? <small className="text-danger ms-1">Required</small>
                                    : null
                                }
                            </div>
                            <div className="col-12 col-sm-2 col-md-1">
                                <label className='form-label'>Password</label>
                            </div>
                            <div className="col-12 col-sm-4 col-md-3">
                                <InputStyled
                                    type="text"
                                    className="form-control"
                                    autoComplete='off'
                                    {...formik.getFieldProps('APIIntegration.password')}
                                    fontSize={fontSize}
                                    error={formik.errors.APIIntegration?.password && formik.touched.APIIntegration?.password}
                                />
                                {formik.errors.APIIntegration?.password && formik.touched.APIIntegration?.password
                                    ? <small className="text-danger ms-1">Required</small>
                                    : null
                                }
                            </div>
                        </>
                    : ['UPS', 'UPSRESTAPI', 'UPSSPRESTAPI', 'UPSSPRESTVOLUME'].indexOf(APISelected?.APICode) !== -1 ?    
                        <>
                            <div className="col-12 col-sm-2 col-md-1">
                                <label className='form-label'>Client Id</label>
                            </div>
                            <div className="col-12 col-sm-4 col-md-3 mb-5 mb-sm-0">
                                <InputStyled
                                    type="text"
                                    className="form-control"
                                    autoComplete='off'
                                    {...formik.getFieldProps('APIIntegration.username')}
                                    fontSize={fontSize}
                                    error={formik.errors.APIIntegration?.username && formik.touched.APIIntegration?.username}
                                />
                                {formik.errors.APIIntegration?.username && formik.touched.APIIntegration?.username
                                    ? <small className="text-danger ms-1">Required</small>
                                    : null
                                }
                            </div>
                            <div className="col-12 col-sm-2 col-md-1">
                                <label className='form-label'>Secret</label>
                            </div>
                            <div className="col-12 col-sm-4 col-md-3">
                                <InputStyled
                                    type="text"
                                    className="form-control"
                                    autoComplete='off'
                                    {...formik.getFieldProps('APIIntegration.password')}
                                    fontSize={fontSize}
                                    error={formik.errors.APIIntegration?.password && formik.touched.APIIntegration?.password}
                                />
                                {formik.errors.APIIntegration?.password && formik.touched.APIIntegration?.password
                                    ? <small className="text-danger ms-1">Required</small>
                                    : null
                                }
                            </div>
                        </>
                    : null
                }
            </div>
            {
                APISelected?.APICode !== 'CARGOCHIEF' ?
                    <div className="row align-items-center mt-5">
                        {
                            APISelected?.APICode !== 'TFORCE' ?
                                <>
                                    <div className="col-12 col-sm-2 col-md-1 mb-0 mb-sm-5 mb-md-0">
                                        <label className='form-label'>Account#</label>
                                    </div>
                                    <div className="col-12 col-sm-10 col-md-3 mb-5 mb-md-0">
                                        <InputStyled
                                            type="text"
                                            className="form-control"
                                            autoComplete='off'
                                            {...formik.getFieldProps('APIIntegration.account')}
                                            fontSize={fontSize}
                                            error={formik.errors.APIIntegration?.account && formik.touched.APIIntegration?.account}
                                        />
                                        {formik.errors.APIIntegration?.account && formik.touched.APIIntegration?.account
                                            ? <small className="text-danger ms-1">Required</small>
                                            : null
                                        }
                                    </div>
                                    {
                                        ['UPS', 'UPSRESTAPI', 'UPSSPRESTAPI', 'UPSSPRESTVOLUME'].indexOf(APISelected?.APICode) === -1 ?
                                        <>
                                            <div className="col-12 col-sm-2 col-md-1">
                                                <label className='form-label'>Access Code</label>
                                            </div>
                                            <div className="col-12 col-sm-4 col-md-3 mb-5 mb-sm-0">
                                                <InputStyled
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    {...formik.getFieldProps('APIIntegration.accessCode')}
                                                    fontSize={fontSize}
                                                    error={formik.errors.APIIntegration?.accessCode && formik.touched.APIIntegration?.accessCode}
                                                />
                                                {formik.errors.APIIntegration?.accessCode && formik.touched.APIIntegration?.accessCode
                                                    ? <small className="text-danger ms-1">Required</small>
                                                    : null
                                                }
                                            </div>
                                        </>
                                        : null
                                    }
                                </>
                            : null
                        }
                        <div className="col-12 col-sm-2 col-md-1">
                            <label className='form-label'>Extra Field</label>
                        </div>
                        <div className="col-12 col-sm-4 col-md-3">
                            <InputStyled
                                type="text"
                                className="form-control"
                                autoComplete='off'
                                {...formik.getFieldProps('APIIntegration.extraField')}
                                fontSize={fontSize}
                                error={formik.errors.APIIntegration?.extraField && formik.touched.APIIntegration?.extraField}
                            />
                            {formik.errors.APIIntegration?.extraField && formik.touched.APIIntegration?.extraField
                                ? <small className="text-danger ms-1">Required</small>
                                : null
                            }
                        </div>
                    </div>
                : null
            }
            {
                APISelected?.APICode !== 'CARGOCHIEF' ?
                    <div className="row align-items-center mt-5">
                        <div className="col-1"></div>
                        <div className="col-3"></div>
                        <div className="col-1"></div>
                        {
                            ['UPS', 'UPSRESTAPI', 'UPSSPRESTAPI', 'UPSSPRESTVOLUME'].indexOf(APISelected?.APICode) === -1
                            ? <>
                                <div className="col-12 col-md-3 mb-5 mb-md-0">
                                    <button
                                        className='btn btn-primary w-100'
                                        onClick={() => setOpenRestrictionsModal(true)}
                                    >
                                        Set Restrictions
                                    </button>
                                </div>
                                <div className="col-1"></div>
                                <div className="col-12 col-md-3">
                                    <button
                                        className='btn btn-primary w-100 d-flex justify-content-center align-items-center'
                                        onClick={() => testConnection(false)}
                                    >
                                        Test Connection{testingConnection && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                                    </button>
                                </div>
                            </>
                            : <>
                                <div className="col-12 col-md-3 mb-5 mb-md-0">
                                </div>
                                <div className="col-1"></div>
                                <div className="col-12 col-md-3">
                                    <button
                                        className='btn btn-primary w-100'
                                        onClick={() => setOpenRestrictionsModal(true)}
                                    >
                                        Set Restrictions
                                    </button>
                                </div>
                            </>
                        }
                    </div>
                : null
            }
            <RestrictionsModal
                open={openRestrictionsModal}
                setOpen={setOpenRestrictionsModal}
                editVendor={true}
                selectedRow={formik.values.APIIntegration?.restrictions}
                setDataFormik={formik.setFieldValue}
            />
        </>
    )
}

export default APIIntegration